module.exports = __webpack_public_path__ + "media/images/compare/phone_rotate-fa78f3b9e8e61f0c10b1dfd95721ed9e.svg";